import { render, staticRenderFns } from "./footer-card.vue?vue&type=template&id=bb790d3c&scoped=true&"
import script from "./footer-card.vue?vue&type=script&lang=js&"
export * from "./footer-card.vue?vue&type=script&lang=js&"
import style0 from "./footer-card.vue?vue&type=style&index=0&id=bb790d3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb790d3c",
  null
  
)

export default component.exports